import {PersonnelVI} from "./personnel/vi";
import {AssetVI} from "./assest/vi";
import {WageVI} from "./wage/vi";

export const HrmVI = {
    ...PersonnelVI,
    ...AssetVI,
    ...WageVI
}